import axios from 'axios'
import { takeEvery, put, all, call } from 'redux-saga/effects'
import { application } from '../../../../../redux/store'
import { ApartmentSingleTypes } from './types'
import { showApartment, addSingleDebt, filterLoad } from './slice'
import toast from 'react-hot-toast'
function* showSingleDebtHandler({ payload }) {
  try {
    const buildings =
      payload.id?.length > 0 ? payload.id?.map((item) => item.id) : null
    const requestPayload = {
      buildings: buildings?.length > 0 ? buildings : null,
    }
    // is_resident sadece null değilse ekle (null veya undefined ise ekleme)
    if (payload.is_resident !== undefined && payload.is_resident !== null) {
      requestPayload.is_resident = payload.is_resident
    }
    // İsim filtresi varsa ekle
    if (payload.name) {
      requestPayload.name = payload.name
    }
    const response = yield call(() =>
      axios.post(`${application.api}/apartments/only/resident`, requestPayload)
    )
    yield put(showApartment(response.data.data || []))
    yield put(filterLoad(false))
  } catch (error) {
    yield put(showApartment(error.response?.data?.data || []))
    yield put(filterLoad(false))
  }
}

function* filterLoadHandler() {
  yield put(filterLoad(true))
}

function* addSingleDebtHandler({ payload }) {
  if (!payload.is_interest) {
    payload.interest = null
  }

  payload.apartments = (payload.apartments || [])
    .filter((el) => {
      const str = String(el.amount).trim()
      const amount =
        str.includes(',') && !str.includes('.')
          ? parseFloat(str.replace(',', '.'))
          : parseFloat(str)
      return amount > 0
    })
    .map((item) => {
      const str = String(item.amount).trim()
      const amount =
        str.includes(',') && !str.includes('.')
          ? parseFloat(str.replace(',', '.'))
          : parseFloat(str)

      return {
        apartment_id: item.apartment_id,
        building_id: item.building_id,
        amount,
        type: item.type,
        apartment_identifier: item.identifier,
        building_identifier: item.building_identifier,
      }
    })

  if (!payload.apartments.length) {
    toast.error('Gönderilecek daire bulunamadı')
    return
  }

  try {
    const response = yield call(() =>
      axios.post(`${application.api}/debt/single`, payload)
    )
    toast.success(response.data.description)
    yield put(addSingleDebt({ debts_error: response.data.data }))
  } catch (error) {
    toast.error(error.response.data.description)
  }
}
export function* ApartmentSingleSagas() {
  yield all([
    takeEvery(
      ApartmentSingleTypes.SHOW_APARTMENT_SINGLE_DEBT,
      showSingleDebtHandler
    ),
    takeEvery(
      ApartmentSingleTypes.SHOW_APARTMENT_SINGLE_DEBT,
      filterLoadHandler
    ),
    takeEvery(ApartmentSingleTypes.ADD_SINGLE_DEBT, addSingleDebtHandler),
  ])
}
